export default __webpack_public_path__ + "static/media/message.e27669ba.mp3";